import { useState, useEffect } from 'react';
import '../common.scss';
import Adv3 from '../../assets/adv3.jpg';
import Adv4 from '../../assets/adv4.jpg';
import Adv7 from '../../assets/adv7.jpg';
import Adv8 from '../../assets/adv8.jpg';
import Adv10 from '../../assets/adv10.jpg';
import Point2 from '../../assets/point2.png';
import Point3 from '../../assets/point3.png';
import Point7 from '../../assets/point7.png';
import cn from 'classnames';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { useNavigate } from 'react-router-dom';
import Reviews from '../../components/Reviews';
import Background from '../../assets/background.jpg';
import Form from '../../components/Form';

const ServicesPage = ({ onFormClick }) => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);
  const [isFormOpen, setFormOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [window.location.pathname]);

  const handleWindowSizeChange = () => {
    setIsMobile(window.innerWidth <= 1200);
  };

  useEffect(() => {
    setIsMobile(window.innerWidth <= 1200);
    window.addEventListener('resize', handleWindowSizeChange);

    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  return (
    <div className='page'>
      <Header onFormClick={() => setFormOpen(true)} />
      <div className='mainScreen'>
        <span className='mainScreenTitle'>
          <span>Going beyond</span> just {isMobile ? '“qualified candidates”' : `“qualified candidates”`}
        </span>
        <span className='mainScreenText'>
          Our human-first, AI-powered recruiting services address the toughest aspects of hiring — from technical skills to
          cultural fit and long-term potential.
        </span>
        <div className='mainScreenTags'>
          <span className='mainScreenTag' onClick={() => navigate('/staffing_solutions')} style={{ cursor: 'pointer' }}>
            Staffing Solutions
          </span>
          <span className='mainScreenTag' onClick={() => navigate('/raas')} style={{ cursor: 'pointer' }}>
            Recruitment-As-A-Service
          </span>
          <span
            className='mainScreenTag'
            onClick={() => window.open('https://ndexecutivesearch.com/', '_blank')}
            style={{ cursor: 'pointer' }}
          >
            Executive Search
          </span>
        </div>
      </div>

      <div className='advantages'>
        <div className='advantagesContent'>
          <span className='blockTitle'>Where Human First Experience and AI technology unite to drive staffing success.</span>
          <div className='advantage'>
            <div className='advantageInfo'>
              <span className='advantageTitle'>Human Connections at Our Core</span>
              <span className='advantageText'>
                While technology helps us search smarter, our networks and human relationships are what make the real impact.
              </span>
            </div>
            <span className='advantageImage'>
              <img src={Adv8} />
            </span>
          </div>
          <div className='advantage'>
            <div className='advantageInfo'>
              <span className='advantageTitle'>AI-Powered Search with Automation</span>
              <span className='advantageText'>
                Our AI technology automates the search, expanding the talent pool and quickly pinpointing the best candidates for
                your needs, all while saving you time and effort.
              </span>
            </div>
            <span className='advantageImage'>
              <img src={Adv3} />
            </span>
          </div>
          <div className='advantage'>
            <div className='advantageInfo'>
              <span className='advantageTitle'>Market Insights to Stay Ahead</span>
              <span className='advantageText'>
                In today’s competitive talent landscape, we give you the edge with real-time insights, so you can attract top-tier
                talent faster than your competition.
              </span>
            </div>
            <span className='advantageImage'>
              <img src={Adv10} />
            </span>
          </div>
          <div className='advantage'>
            <div className='advantageInfo'>
              <span className='advantageTitle'>Recruiting Powered by Technology</span>
              <span className='advantageText'>
                We combine advanced AI with industry expertise to make sure you get candidates who truly fit your team and
                culture.
              </span>
            </div>
            <span className='advantageImage'>
              <img src={Adv7} />
            </span>
          </div>
        </div>
      </div>

      <div className='pointsSection'>
        <span className='blockTitle' style={{ marginBottom: '80px' }}>
          Discover our Human First, AI Powered personalized professional staffing solutions
        </span>
        <div className='points'>
          <div className='point' onClick={() => navigate('/staffing_solutions')} style={{ cursor: 'pointer' }}>
            <span className='pointIcon'>
              <img src={Point7} />
            </span>
            <span className='pointTitle'>Staffing Solutions</span>
            <span className='pointText'>
              Need to fill a tough role in tech, engineering, marketing, finance, or HR? Let our AI-driven, human-centered
              recruiting services handle it for you.
            </span>
          </div>
          <div className='point' onClick={() => navigate('/raas')} style={{ cursor: 'pointer' }}>
            <span className='pointIcon'>
              <img src={Point2} />
            </span>
            <span className='pointTitle'>Recruitment-As-A-Service (RAAS)</span>
            <span className='pointText'>
              Flexible, on-demand hiring solution that helps companies scale recruitment efficiently while reducing costs and
              time-to-hire.
            </span>
          </div>
          <div className='point'>
            <span className='pointIcon'>
              <img src={Point3} />
            </span>
            <span className='pointTitle'>Executive Search</span>
            <span className='pointText'>
              Looking for a visionary to lead your mission-driven organization? Explore our innovative approach to sourcing
              exceptional executives in today’s talent marketplace.
            </span>
          </div>
        </div>
      </div>
      <Reviews />

      <div className='spacer' />

      <div className='adBlock'>
        <span className='adBlockBackgroung'>
          <img src={Background} />
        </span>
        <div className='adBlockDetails'>
          <span className='adBlockTitle'>Finding the perfect match for your position requires looking deeper than a resume.</span>
        </div>
        <span className='adBlockButton' onClick={() => setFormOpen(true)}>
          Find Next Great Hire
          <svg width='28' height='28' viewBox='0 0 28 28'>
            <path
              d='M14 2.625C11.7502 2.625 9.551 3.29213 7.68039 4.54203C5.80978 5.79193 4.35182 7.56847 3.49088 9.64698C2.62993 11.7255 2.40467 14.0126 2.84357 16.2192C3.28248 18.4257 4.36584 20.4525 5.95667 22.0433C7.54749 23.6342 9.57432 24.7175 11.7809 25.1564C13.9874 25.5953 16.2745 25.3701 18.353 24.5091C20.4315 23.6482 22.2081 22.1902 23.458 20.3196C24.7079 18.449 25.375 16.2498 25.375 14C25.3718 10.9841 24.1724 8.09271 22.0398 5.96018C19.9073 3.82764 17.0159 2.62818 14 2.625ZM18.9941 14.6191L15.4941 18.1191C15.3299 18.2833 15.1072 18.3755 14.875 18.3755C14.6428 18.3755 14.4201 18.2833 14.2559 18.1191C14.0918 17.9549 13.9995 17.7322 13.9995 17.5C13.9995 17.2678 14.0918 17.0451 14.2559 16.8809L16.263 14.875H9.62501C9.39294 14.875 9.17038 14.7828 9.00629 14.6187C8.84219 14.4546 8.75001 14.2321 8.75001 14C8.75001 13.7679 8.84219 13.5454 9.00629 13.3813C9.17038 13.2172 9.39294 13.125 9.62501 13.125H16.263L14.2559 11.1191C14.0918 10.9549 13.9995 10.7322 13.9995 10.5C13.9995 10.2678 14.0918 10.0451 14.2559 9.88094C14.4201 9.71675 14.6428 9.62451 14.875 9.62451C15.1072 9.62451 15.3299 9.71675 15.4941 9.88094L18.9941 13.3809C19.0754 13.4622 19.14 13.5587 19.184 13.6649C19.228 13.7712 19.2507 13.885 19.2507 14C19.2507 14.115 19.228 14.2289 19.184 14.3351C19.14 14.4413 19.0754 14.5378 18.9941 14.6191Z'
              fill='white'
            />
          </svg>
        </span>
      </div>
      <Footer />
      {isFormOpen && <Form onClose={() => setFormOpen(false)} />}
    </div>
  );
};

export default ServicesPage;
